<template>
  <group-mobile-grouped-view
    v-model="selectedCategories"
    :loading="loading"
    :has-data="rows.length > 0"
    :days="days"
    :meal-total="mealTotal"
    :meal-categories="mealCategories"
    :shown-categories="shownCategories"
    :category-items="categoryItems"
  >
    <grouped-matrix-data
      ref="mealsTable"
      :loading="loading"
      :daily-data="dailyData"
      :meal-categories="mealCategories"
      :category-labels="categoryLabels"
      :selected-shift="selectedShifts"
      :selected-categories="selectedCategories"
      :date-array="dateArray"
    ></grouped-matrix-data>
  </group-mobile-grouped-view>
</template>

<script>
import CompanyReportTabGroupedShiftMeals from "@/components/company/reports/tabs/CompanyReportTabGroupedShiftMeals.vue";
import GroupMobileGroupedView from "@/components/report/mobile/screens/group/GroupMobileGroupedView.vue";
import GroupedMatrixData from "@/components/report/mobile/screens/group/GroupedMatrixData.vue";
import hasBarShifts from "@/components/report/shared/hasBarShifts";
import hasShiftSubtitle from "@/components/report/shared/hasShiftSubtitle";
import hasGroupedDays from "@/components/report/shared/group/hasGroupedDays";

/**
 * Mobilni "Grupe jela" firme tipa "grupa": za svaki dan perioda koliko je obroka po grupi jela i smeni (kartica po
 * danu). Smene, firme i period su u zaglavlju, grupe jela se biraju u donjoj kartici. Nasleđuje učitavanje, štampu i
 * Excel iz starog taba; za štampu i Excel služi nevidljiva tabela GroupedMatrixData.
 */
export default {
  name: "CompanyMobileGroupGrouped",
  extends: CompanyReportTabGroupedShiftMeals,
  mixins: [hasBarShifts, hasShiftSubtitle, hasGroupedDays],
  components: { GroupMobileGroupedView, GroupedMatrixData },
  computed: {
    groupedDaily() {
      return this.dailyData;
    },
  },
};
</script>
